export const initialStateEmail = {
   asunto: null,
   cuerpo: null,
};

export const initialStateSeguimiento = {
   fecha_resolucion: null,
};

export function getInitialStateBsa() {
   return {
      suscriptores: {},
      suscriptor: {},
      seguimiento: { ...initialStateSeguimiento },
      comentario: null,
      estados: [],
      companias: [],
      companiasAsignadas: [],
      estado: null,
      fecha_resolucion: null,
      mail: { ...initialStateEmail },
      casoAsignado: {},
      descuentos: [],
      descuento: {},
      coberturas: [],
      abms: [],
      optionsAbm: [],
      grupos: [],
      empresas: [],
      secciones: [],
      empresaCompaniaSeccion: [],
   };
}

export default getInitialStateBsa();
